/* eslint-disable prettier/prettier */
import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';


const themeColors = [
	'rgba(239, 239, 242, 1)',
	'rgba(233, 233, 229, 1)',
	'rgba(237, 248, 239, 1)',
	'rgba(195, 234, 227, 1)',
];

interface Props {
	index: number;
}

export const ThemeWrapper = styled.div<Props>`
	.MuiAccordion-rounded.Mui-expanded {
		background: ${(props) => themeColors[props.index % 4]};
	}
	.MuiAccordion-root,
	.MuiAccordion-rounded {
		background: ${(props) => themeColors[props.index % 4]};
	}
	.MuiAccordion-rounded.Mui-expanded {
		.accordion-title {
			color: ${colors.primary} !important;
		}
	}
`;

export const ChallengeWrapper = styled.div`
	margin-bottom: 10px;
	.MuiAccordion-root,
	.MuiAccordion-rounded {
	}
	.challenge-title {
		font-family: 'Signifier-Regular';
		font-size: 2.25rem;
		line-height: 2.5rem;
		letter-spacing: -0.03em;
		color: ${colors.primary};
	}
	.challenge-description {
		font-size: 1rem;
		line-height: 1.5rem;
		color: ${colors.textDark};
	}
	.accordion-title {
		font-family: 'Segnifier-Regular';
		color: ${colors.textDark};
		font-size: 32px;
		text-align: center;
		width: 100%;
		margin: 20px;
	}
	.accordion-body {
		padding: 0px 50px;
		box-sizing: border-box;
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		.accordion-content {
			display: flex;
			flex-direction: column;
			margin: 0;
			color: #37494b;
			font-size: 20px;
			font-style: normal;
			font-weight: 400;
			line-height: 28px;
			letter-spacing: -0.6px;
			margin-bottom: 24px;
		}
	}
	.accordion-img {
		height: 200px;
	}

	.apply-now{
		float: right;
		margin: 20px 0;
	}

	@media ${device.tablet} {
		.challenge-title {
			font-size: 1.8rem;
		}
		.challenge-description {
			line-height: 1.3rem;
		}
		.accordion-img {
			height: 200px;
		}
	}

	@media ${device.mobile} {
		.challenge-title {
			font-size: 1.8rem;
		}
		.challenge-description {
			line-height: 1.3rem;
		}
		.accordion-img {
			width: 100%;
			object-fit: contain;
		}
	}
`;
